import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const locale = 'en-US' // default local

export default new VueI18n({
  locale,
  messages: {
    'en-US': {
      general: {
        yes: 'YES',
        no: 'NO',
        start: 'START',
        skip: 'Skip',
        next: 'CONTINUE',
        done: 'Done',
        missingFields: 'Missing fields',
        oneItemError: 'You have to select at least one element',
        selectOptionError: 'You have to choose an option',
        pleaseSpecifyError: 'Please specify your answer'
      },
      privacy: {
        title: 'Your privacy is important to us.',
        info: 'Your data is only used to display aggregate statistics for population health. We do not collect your name or date of birth, and we do not sell your data. To continue, please select start.',
        copyright: '2021 Copyright Bowhead Health Inc. All Rights Reserved. ',
        terms: 'Terms of Use',
        and: ' and ',
        privacy: 'Privacy Policy'
      },
      gender: {
        hello: 'Hello,',
        started: 'Let\'s get started with the basics!',
        male: 'MALE',
        female: 'FEMALE',
        nonBinary: 'NON-BINARY'
      },
      whoAreYou: {
        name: 'Nickname',
        birth: 'Age',
        weight: 'Weight',
        height: 'Height',
        lbs: 'lbs',
        ft: 'ft',
        missingFields: 'Please check your answers',
        legalAge: 'Age out of the range',
        termsAndConditions: 'Terms and conditions',
        privacyPolicy: 'Privacy policy',
        cancel: 'CANCEL',
        accept: 'ACCEPT'
      },
      chronicCondition: {
        title: 'Do you have an existing chronic condition?',
        asthma: 'Asthma',
        copd: 'COPD',
        heart: 'Heart disease',
        diabetes: 'Diabetes',
        hypertension: 'Hypertension',
        ad: 'Autoimmune disease'
      },
      pandemicAffected: {
        title: 'How has the pandemic affected you?',
        note: '0 being not affected and 10 being the worst affected.',
        work: 'Work',
        mentalHealth: 'Mental Health',
        family: 'Social life/friendships',
        finances: 'Finances',
        lostSomeone: 'Death of family or close friends',
        physicalHealth: 'Physical health',
        notAtAll: 'Not at all',
        rangeInfo: '0 being not affected and 10 being the worst affected.'
      },
      catchCovid: {
        title: 'Were you infected with SARS-CoV-2 (coronavirus disease)?'
      },
      wouldGetVaccinated: {
        title: 'Would you get treatment to help lower your risk for infection (vaccine, antibodies, etc)'
      },
      treatmentOpenToGetting: {
        title: 'Which treatment would you be open to getting?',
        next: 'NEXT',
        modernaVaccine: 'Moderna vaccine',
        pfizerVaccine: 'Pfizer vaccine',
        lillyAntibody: 'Lilly Antibodies',
        rocheAntibody: 'Roche Antibodies',
        gileadDrug: 'Gilead drug',
        novavaxVaccine: 'Novavax vaccine',
        inovioVaccine: 'Inovio vaccine',
        abbvieDrug: 'AbbVie drug',
        regeneronAntibody: 'Regeneron Antibodies',
        gskVaccine: 'GSK vaccine',
        other: 'Other'
      },
      preventativeHealth: {
        title: 'Have you recently taken any preventative health precautions to strengthen your immune system?',
        vitaminD: 'Vitamin D',
        zinc: 'Zinc',
        vitaminC: 'Vitamin C',
        fitness: 'Fitness',
        healthyDiet: 'Healthy diet',
        no: 'No',
        other: 'Other'
      },
      whyConcerned: {
        title: 'Why are you concerned?',
        other: 'Other',
        dontThinkWork: 'I don’t think it will work',
        priceTreatment: 'Price of treatment',
        dontTrust: 'I don’t trust drug manufacturers',
        scared: 'I’m scared it will hurt me',
        why: 'Why?'
      },
      worryAboutRisk: {
        title: 'Do you continue to worry about the risk factors after taking treatment?'
      },
      householdIncome: {
        title: 'What is your approximate average household income?',
        range1: '$0-$24,999',
        range2: '$25,000-$49,999',
        range3: '$50,000-$74,999',
        range4: '$75,000-$99,999',
        range5: '$100,000-$124,999',
        range6: '$125,000-$149,999',
        range7: '$150,000-$174,999',
        range8: '$175,000-$199,999',
        range9: '$200,000 and up'
      },
      concernedAboutVaccination: {
        title: 'Are you concerned about vaccination or other treatments for COVID 19?'
      },
      ethnicity: {
        title: 'Which race/ethnicity best describes you?',
        americanIndian: 'American Indian or Alaskan Native',
        african: 'Black or African American',
        caucasian: 'White/Caucasian',
        asian: 'Asian/Pacific Islander',
        hispanic: 'Hispanic',
        multiple: 'Multiple Ethnicity/Other',
        specify: 'Please specify',
        selectOption: 'Select Option'
      },
      education: {
        title: 'What is the highest level of education you have completed?',
        selectOption: 'Select Option',
        notAttendSchool: 'Did not attend school',
        elementarySchool: 'Elementary school',
        highSchool: 'High school',
        bachelor: 'Bachelor’s Degree',
        graduate: 'Completed graduate school'
      },
      sourceOfStress: {
        title: 'From 0 to 10, has the risk of getting the virus been a source of stress?',
        info: '10 being the most stressful and 0 being the least stressful.'
      },
      results: {
        title: 'Results',
        globalDataResults: 'Global Data Results',
        respondets: '{number} respondents',
        male: 'Male',
        female: 'Female',
        other: 'Other',
        noOfRespondents: 'No. of respondents',
        globalMap: 'Global Map',
        ageDistribution: 'Age Distribution',
        ageRange1: '18-29',
        ageRange2: '30-39',
        ageRange3: '40-49',
        ageRange4: '50-59',
        ageRange5: '60-69',
        ageRange6: '70-79',
        ageRange7: '80+',
        caughtCovid: 'Have you caught covid?',
        yes: 'Yes',
        no: 'No',
        kindTreatment: 'What kind of treatment did you receive',
        pfizer: 'Pfizer',
        moderna: 'Moderna',
        aztrazeneca: 'Aztrazeneca',
        roche: 'Roche Antinodies',
        lilly: 'Lilly Antibodies',
        wouldTakeVaccine: 'Would you get treatment Yes/No',
        whyConcerned: 'Why are you concerned?',
        safety: 'Safety',
        cost: 'Cost',
        socialMedia: 'Social media'
      },
      thankYou: {
        title: 'Thank you for participating in this survey.',
        info: 'Do you consent to sharing this information with researchers to support population health research?',
        agree: 'AGREE',
        notAgree: 'I DO NOT AGREE',
        sendingData: 'Sending Information'
      },
      almostDone: {
        title: 'Thank you! You’re almost done. Just a few more questions.',
        continue: 'CONTINUE'
      }
    }
  }
})
